module.exports = __webpack_public_path__ + "static/img/cadrage_bg_3.39f0bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg_3.jpg
// module id = hy3W
// module chunks = 1